import { AxiosError } from "axios";
import { useUserStore } from "@/stores/user";
import { useDialog } from "@/stores/dialog";

export default function logout(error: AxiosError): Promise<never> {
  if (!error.response) {
    return Promise.reject(error);
  }

  if (error.response.status !== 401) {
    return Promise.reject(error);
  }

  useUserStore().logout();
  useDialog().show("/login");

  return Promise.reject(error);
}
